import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, parentesco_ } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const Parentesco = ({ id, permisos }) => {
    const [ tiposParentesco, setTiposParentesco ] = useState( null );
    useEffect(() => {
        axiosTiposParentesco();
    }, []);

    const axiosTiposParentesco = () => {
        axios.get( `${servicios_grupogack_catalogo}/tipoparentesco/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        setTiposParentesco( respuesta.data.dataResponse );
                        break;
                    case 404:
                        setTiposParentesco([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })
    }

    return (
        <div id={ id }>
            { tiposParentesco ?
                <DataTableService id={id} title={ parentesco_ } permisos={permisos}
                    columns={[
                        { field: "parentescoCve", title: "Clave" },
                        { field: "parentescoNom", title: "Nombre" },
                    ]}
                    data={ tiposParentesco } /> : <SpinnerOval />
            }
        </div>
    );
}
 
export default Parentesco;